// removed by extract-text-webpack-plugin
module.exports = {"transaction-details":"transaction-details__1F6j1"};


//////////////////
// WEBPACK FOOTER
// ./styles/paymentSuccess.scss
// module id = 1225
// module chunks = 68